import React, { useState } from 'react';

import Form from '../../components/common/Form';
import FormField from '../../components/common/FormField';
import FormSection from '../../components/common/FormSection';
import {
  useFormValidation,
  ValidationRules,
} from '../../hooks/useFormValidation';
import { MemberTypeDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';

interface MemberTypeFormProps {
  initialValues: MemberTypeDTO;
  onSubmit: (data: MemberTypeDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information',
  },
} as const;

const validationRules: ValidationRules = {
  name: [{ required: true, message: 'Name is required' }],
};

const MemberTypeForm: React.FC<MemberTypeFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false,
}) => {
  const [formData, setFormData] = useState<MemberTypeDTO>({
    isActive: true,
    ...initialValues,
  });

  const { errors, validate } =
    useFormValidation<MemberTypeDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form
      sections={sections}
      onSave={handleSave}
      onCancel={onCancel}
      isSubmitting={isLoading}
    >
      <FormSection
        id={FORM_SECTIONS.basicInfo.id}
        title={FORM_SECTIONS.basicInfo.title}
      >
        <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required
          error={errors.name}
        />
        <FormField
          id="description"
          label="Description"
          type="textarea"
          value={formData.description || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Description"
          error={errors.description}
        />
        <FormField
          id="displayOrder"
          label="Display Order"
          type="number"
          value={formData.displayOrder ?? ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Display Order"
          error={errors.displayOrder}
        />
        <FormField
          id="isActive"
          label="Is Active"
          type="checkbox"
          value={formData.isActive ?? true}
          onChange={(e) => handleChange(e, setFormData)}
          error={errors.isActive}
        />
      </FormSection>
    </Form>
  );
};

export default MemberTypeForm;
